<template>
    <div class="propiedades-container">

        <div class="propiedades-content">
            <template v-if="grupos.length">

                <el-collapse v-model="propiedadesCollapse" style="margin-bottom: 20px">
                    <el-collapse-item
                        v-for="(grupo,i) in grupos"
                        :key="i"
                        :title="grupo.descripcion"
                        :name="i">

                        <TabPanel
                            :tabs="grupo.estructura.map((e,e_index) => { return { label: `${e_index}` } })"
                            :showTabs="grupo.estructura.length > 1"
                            type="card">

                            <div
                            v-for="(tab, i) in grupo.estructura"
                            :key="i"
                            :slot="`tab-${i}`">
                                <ul class="properties">
                                    <li
                                        v-for="(dato, mdi) in tab"
                                        :key="mdi">

                                        <label :class="[{required: !!dato.requerido}]">{{dato.descripcion.replace(/_|#|-|@|<>/g, " ")}}</label>

                                        <InputLlood
                                            ref="propiedades_input"
                                            :input="dato"
                                            :type="input_types[dato.tipo__id]"
                                            :value="input_types[dato.tipo__id] == 'datepicker' ? ['0000-00-00',null,''].includes(dato.valor) ? '' : moment(dato.valor, 'YYYY-MM-DD').format('DD/MM/YYYY') : dato.valor"
                                            :siblings="propiedadesInputList"
                                            :readonly="!!dato.read_only || !dato.editable || !propiedadesEditable"
                                            :clearable="false"
                                            @input="val => dato.valor = input_types[dato.tipo__id] == 'datepicker' ? moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD') : val"
                                            />

                                    </li>
                                </ul>
                            </div>

                        </TabPanel>
                    </el-collapse-item>
                </el-collapse>

                <el-form style="margin-bottom: 20px" v-if="showDescription">
                    <el-form-item label="Descripción" :class="[{editable: propiedadesEditable}]">
                        <el-input
                            v-model="descripcion_elemento"
                            :readonly="!propiedadesEditable"
                            :rows="4"
                            type="textarea"/>
                    </el-form-item>
                </el-form>
            </template>

            <el-alert
                v-else
                :closable="false"
                center
                title="No hay propiedades"
                type="info">
            </el-alert>
        </div>

        <div class="propiedades-action">
            <el-button
                v-if="!propiedadesEditable"
                @click="setPropiedadesEdit()"
                class="propiedades-action--edit"
                type="primary"
                icon="el-icon-edit">
                Editar
            </el-button>

            <template v-else>
                <el-button
                    v-if="showCancel"
                    @click="setPropiedadesCancel()"
                    plain
                    type="default">
                    Cancelar
                </el-button>

                <el-button
                    @click="setPropiedadesSave()"
                    class="propiedades-action--edit"
                    type="primary"
                    icon="el-icon-upload2">
                    Guardar
                </el-button>
            </template>
        </div>

    </div>
</template>

<script>
import {
    savePropiedades
} from "../api/api.js";

import TabPanel from './TabPanel'
import InputLlood from './inputs/InputLlood.vue'
import moment from 'moment'

import { input_types } from '../config.js'

export default {
  name: 'Propiedades',
  components: {
    InputLlood,
    TabPanel
  },
  props: {
    id: {
        type: Number
    },
    esquema: {
        type: Object
    },
    descripcion: {
        type: String,
        default: ''
    },
    editable: {
        type: Boolean,
        default: false
    },
    showDescription: {
        type: Boolean,
        default: true
    },
    showCancel: {
        type: Boolean,
        default: true
    }
  },
  data() {
    return {
        moment,
        input_types,

        propiedadesGrupos: [], // Propiedades sin modificar
        propiedadesCollapse: [],
        propiedadesEditable: false,
        propiedadesInputList: [],
        descripcion_elemento: '',

        // Grupos de propiedades modificados
        grupos: [],
        grupo_activo: ''
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    requeridos () {
        return this.grupos.map(g => {

            return g.estructura.reduce((acum, estr) => {

                acum += estr.filter(e => e.requerido && e.valor === '').length

                return acum

            }, 0)

        })
    }
  },
  watch: {
    esquema() {
        this.propiedadesEditable = false
        this.init()
    },
    id() {
        this.propiedadesEditable = false
        this.init()
    },
    propiedadesGrupos() {
        this.getGrupos()
    }
  },
  methods: {
    init() {
        let esquema = JSON.parse(JSON.stringify(this.esquema))

        this.propiedadesCollapse = esquema.grupos.map((m,i) => i) || []
        this.propiedadesGrupos = esquema.grupos || []
        this.descripcion_elemento = this.descripcion

        this.propiedadesEditable = this.editable
    },
    setPropiedadesEdit() {
        this.propiedadesEditable = true
    },
    setPropiedadesCancel() {
        let esquema = JSON.parse(JSON.stringify(this.esquema))

        this.propiedadesGrupos = esquema.grupos
        this.descripcion_elemento = this.descripcion
        this.propiedadesEditable = false

        this.$emit('loading', false)
    },
    async setPropiedadesSave() {

        if (this.requeridos.some(r => r !== 0)) {
            this.$notify.error({
                title: 'Error',
                message: 'Completa los campos requeridos'
            });
            return
        }

        this.$emit('loading', true)

        try {

            let metadatos = []
            this.grupos.forEach(m => {
                m.estructura.forEach(e => {
                    e.forEach((prop) => {
                        metadatos.push({
                            id: prop.id,
                            valor: prop.valor
                        })
                    })
                })
            })

            let data = {
                elemento: this.id, // DUDA !!
                metadatos: metadatos,
                esquema: this.esquema.id
            }

            if (this.showDescription) data.descripcion_elemento = this.descripcion_elemento

            let resp = await savePropiedades(this.id, data)

            this.esquema.grupos = this.grupos

            this.$notify.success({
                title: '!Bien!',
                message: 'Propiedades actualizadas correctamente'
            })

            this.propiedadesEditable = false

            this.$emit('save')

        } catch (err) {

            this.$notify.error({
                title: '!Ups!',
                message: 'Ha ocurrido un error al guardar propiedades'
            })

            this.propiedadesGrupos = JSON.parse(JSON.stringify(this.esquema.grupos))
        }

        this.$emit('loading', false)

    },
    setPropiedadesInputList() {
        this.propiedadesInputList = this.$refs.propiedades_input.filter(f => !f.readonly).map(input => input)
    },

    // GESTOR ARCHIVOS
    getGrupos() {

        let esquema = JSON.parse(JSON.stringify(this.esquema))

        this.grupos = esquema.grupos.map(grupo => {

            // Generar tabs en funcion del parametro "multiplicado"
            let tabsPadres = []
            for (let i = 1; i <= grupo.multiplicado; i++) {

                const padres = grupo.estructura.filter(md => md.padre__id === null).map(md => ({
                    hijos: [],
                    valor: '',
                    ...md
                })).sort((a, b) => parseInt(a.orden) - parseInt(b.orden))

                /*grupo.estructura.filter(md => md.padre__id !== null).forEach(md => {
                    padres.find(padre => padre.id === md.padre__id).hijos.push(md)
                })*/

                tabsPadres.push(padres)
            }
            
            return {
                ...grupo,
                estructura: tabsPadres,
                requeridos: tabsPadres[0].filter(md => md.requerido && md.valor === '').length
            }

        }).sort((a, b) => parseInt(a.orden) - parseInt(b.orden))

        setTimeout(() => {
            this.setPropiedadesInputList()
        }, 200)
    }
  }
}
</script>

<style lang="scss">
.propiedades-content {
    ul.properties {
        padding: 0px;
        margin: 0px 0px 10px 0px;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        line-height: 2;
        li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #eaecf0;
            font-size: 0.85rem;
            label {
                flex-grow: 1;
                min-width: 150px;
                max-width: 150px;
                background-color: #fafafa;
                padding: 6px 9px;
                border-right: 1px solid #dcdfe6;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                flex-shrink: 0;
                text-transform: uppercase;
                font-weight: 500;
                font-size: 0.71rem;
                &.required {
                    &:before {
                        content: "*";
                        color: #f56c6c;
                        margin-right: 4px;
                    }
                }
            }
            form.input-llood {
                flex-grow: 1;
                input {
                    height: auto;
				    border-radius: 0px;
				    border: 1px solid #409EFF;
                }
                &:not(.readonly) {
                    .label {
                        color: #409eff;
                    }
                }
            }
            // descripcion_elemento
            .el-form-item.editable textarea {
                color: #409eff;
            }
            p {
                margin: 0px;
                flex-grow: 1;
                padding: 4px 9px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            &:last-child {
                border: 0px;
            }
        }
    }
}
.propiedades-action {
    border-top: 1px solid #ebeef5;
    padding-top: 10px;
    text-align: right;
    display: flex;
    button {
        &.propiedades-action--edit {
            width: 100%;
        }
        &.propiedades-action--save {
            flex-grow: 1;
        }
    }
}
</style>
